import * as React from "react";

export const IconAlertWarning = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_38085_58687)">
      <path
        d="M0.666504 14.0002H15.3332L7.99984 1.3335L0.666504 14.0002ZM8.6665 12.0002H7.33317V10.6668H8.6665V12.0002ZM8.6665 9.3335H7.33317V6.66683H8.6665V9.3335Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_38085_58687">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
